/* The same file can be included by older theme layouts. The shared guard keeps
   the mobile drawer on one click controller even when both legacy assets load. */
(() => {
  if (window.__scpMobileDrawerControllerV4) return
  window.__scpMobileDrawerControllerV4 = true
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return

  const rootSelector = 'header-drawer > details.menu-drawer-container'
  const summarySelector = `${rootSelector} > summary.header__icon--menu`

  const closeDrawer = (details, summary) => {
    details.classList.remove('menu-opening')
    details.removeAttribute('open')
    summary?.setAttribute('aria-expanded', 'false')
    document.body.classList.remove('overflow-hidden-tablet')
  }

  const openDrawer = (details, summary) => {
    const header = document.querySelector('.shopify-section-header')
    if (header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.round(header.getBoundingClientRect().bottom)}px`
      )
    }
    details.setAttribute('open', '')
    summary.setAttribute('aria-expanded', 'true')
    document.body.classList.add('overflow-hidden-tablet')
    window.requestAnimationFrame(() => details.classList.add('menu-opening'))
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null
    const summary = target?.closest(summarySelector)
    if (!summary) return
    const details = summary.parentElement
    if (!details) return

    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    if (details.open) closeDrawer(details, summary)
    else openDrawer(details, summary)
  }, true)

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return
    document.querySelectorAll(`${rootSelector}[open]`).forEach((details) => {
      closeDrawer(details, details.querySelector(':scope > summary'))
    })
  })
})()
